import { GET_SPACES_OK, GET_CURRENT_SPACE_OK } from "../actions";


const initState = null

export default function(state = initState, action) {
  switch (action.type) {
    case GET_SPACES_OK:
      return {
        ...state,
        allSpaces: action.payload
      }
  
    case GET_CURRENT_SPACE_OK: {
      return {
        ...state,
        currentSpace: {
          users: action.payload.users,
          groups: action.payload.groups,
          passwords: action.payload.passwords
        }
      }
    }
    default:
      return state
  }
  
}


// WEBPACK FOOTER //
// ./src/reducers/spaces.js